module.exports = __webpack_public_path__ + "img/9.fb2a302e.jpg";